import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {UserService} from "../services";
import {User} from "../models"
import {Items} from "../models/items";

@Injectable()
export class ResourceUsersResolve implements Resolve<Items> {
    constructor(private userService: UserService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Items> {
        return this.userService.getAllResources();
    }
}